import bootstrapTheme from 'typography-theme-bootstrap'

import { TypographyOptions } from './types'

export const typography: TypographyOptions = {
  ...bootstrapTheme,
  title: 'System',
  baseFontSize: '16px',
}
